"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FourMediaLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FourMediaLayout = (param)=>{
    let { banner, debug, modulePosition, className } = param;
    const { modules, layout, id } = banner;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!modules || modules.length < 1) {
        return (0, _utils.getModulesLengthError)({
            debug,
            layout,
            modulePosition
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.FourMedia),
        children: modules.map((module, index)=>{
            var _module_content;
            const { title, titleStorybookColor } = (_module_content = module === null || module === void 0 ? void 0 : module.content) !== null && _module_content !== void 0 ? _module_content : {};
            var _module_link;
            const link = (_module_link = module === null || module === void 0 ? void 0 : module.link) !== null && _module_link !== void 0 ? _module_link : null;
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key -- no unique index
            (0, _jsxRuntime.jsxs)(_styles.FourMediaItem, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ImageBox, {
                        module: module,
                        id: id,
                        imageParams: _constants.IMAGE_PARAMS.params,
                        sizes: _constants.IMAGE_PARAMS.sizes,
                        height: _constants.IMAGE_DESKTOP_WIDTH,
                        width: _constants.IMAGE_DESKTOP_WIDTH
                    }),
                    title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Title, {
                        titleVariant: "h5",
                        title: title,
                        maxLines: 2,
                        color: titleStorybookColor
                    }) : null,
                    link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Button, {
                        link: link
                    }) : null
                ]
            }, index));
        })
    });
};
exports.FourMediaLayout = FourMediaLayout;
